import { useMemo, useState } from 'react'
import AssocUserOperacaoPatrimonialHttp from '../../../../services/api/https/patrimonio/assoc-user-operacao-patrimonial.http'

export const LOADING_MESSAGE = {
  NONE: 'NONE',
  FETCH: 'Obtendo os Locais de Movimentações . . .',
  FETCH_ASSOCIACOES: 'Obtendo as Operações Patrimoniais . . .',
  ASSOCIANDO: 'Atualizando as associações',
}

const INIT_STATE = {
  errorMessage: null,
  loadingMessage: LOADING_MESSAGE.NONE,
  associacoes: [],
  locaisMovimentacao: [],
  selectedLocal: '',
  selectedAssociacao: null,
}

export default function useAssocUsuarioOperacaoPatrimonial() {
  const [state, setState] = useState({ ...INIT_STATE })

  const localDispatch = useMemo(() => {
    // ********* Private
    const errorHandler = errorValue => {
      setState(prev => ({
        ...prev,
        errorMessage: errorValue,
        loadingMessage: LOADING_MESSAGE.NONE,
      }))
    }
    // ********* Public
    return {
      // Action
      loadAssociacoes() {
        setState(prev => ({ ...prev, loadingMessage: LOADING_MESSAGE.FETCH_ASSOCIACOES }))
      },

      fetchAssociacoes(local) {
        AssocUserOperacaoPatrimonialHttp.getAssocByUserLocal(local.user_local_id)
          .then(associacoes => {
            setState(prev => ({
              ...prev,
              loadingMessage: LOADING_MESSAGE.NONE,
              associacoes,
            }))
          })
          .catch(errorHandler)
      },

      associacaoHandler(selectedAssociacao) {
        AssocUserOperacaoPatrimonialHttp.associacaoHandler(selectedAssociacao)
          .then(associacoes => {
            setState(prev => ({
              ...prev,
              loadingMessage: LOADING_MESSAGE.NONE,
              associacoes,
            }))
          })
          .catch(errorHandler)
      },

      // Event
      onInit() {
        setState(prev => ({ ...prev, loadingMessage: LOADING_MESSAGE.FETCH }))
      },

      onFetchInfo(usuario) {
        AssocUserOperacaoPatrimonialHttp.getSistemaTelaInfo(usuario)
          .then(locais => {
            setState(prev => ({
              ...prev,
              loadingMessage: LOADING_MESSAGE.NONE,
              locaisMovimentacao: locais,
            }))
          })
          .catch(errorHandler)
      },

      onResetState() {
        errorHandler(null)
      },

      onNovoClick() {
        setState(prev => ({ ...prev, showModal: true, selectedOperacao: null }))
      },

      onRowClicked(selectedAssociacao) {
        setState(prev => ({
          ...prev,
          loadingMessage: LOADING_MESSAGE.ASSOCIANDO,
          selectedAssociacao,
        }))
      },

      onLocalMovimentacaoChange(local) {
        setState(prev => ({ ...prev, selectedLocal: local }))
      },
    }
  }, [])

  return { state, localDispatch }
}
